import PageLayout from "@/components/base/page-layout";
// import Stats from "@/components/statistics";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import React from "react";
import useQueryProducts from "@/hooks/queries/useQueryProducts";
import Products from "@/components/products/table";
import Backdrop from "@/components/base/backdrop";

const DashboardPage: React.FC = () => {
  const { data: products, isFetching } = useQueryProducts();

  if (!products) {
    return <Backdrop loading={isFetching} />;
  }

  return (
    <PageLayout title="Dashboard">
      {/* <Stats /> */}
      <Products data={products} />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "DashboardPage" })(DashboardPage);
